<div class="pipeline-container content">
  <div class="index-list">
    <h4>Domain</h4>
    <mat-form-field>
      <mat-label>Domain</mat-label>
      <mat-select (selectionChange)="setDomain()" [(ngModel)]="selectedDomain">
        @for (domain of domains; track domain) {
          <mat-option [value]="domain">{{domain}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <button mat-stroked-button type="button" (click)="clearDomain()">Clear</button>

    <h4>Code System</h4>
    <mat-form-field>
      <mat-label>Code System</mat-label>
      <mat-select (selectionChange)="setCodeSystems()" [(ngModel)]="selectedCodeSystems" multiple>
        @for (codeSystem of codeSystems; track codeSystem) {
          <mat-option [value]="codeSystem">{{codeSystem}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <button mat-stroked-button type="button" (click)="clearCodeSystem()">Clear</button>
  </div>

  @if (pipeline) {
    <div class="detail">
      <app-pipeline-detail [pipeline]="pipeline"></app-pipeline-detail>
    </div>
  }
</div>

